import {
  applyMiddleware,
  combineReducers,
  legacy_createStore as createStore,
  compose,
} from "redux";
import { thunk } from "redux-thunk";
import { sessionReducer, sessionService } from "redux-react-session";
import common from "./reducer";
import { getIsAuthenticated } from "../components/constants";

const appReducer = combineReducers({ common: common, session: sessionReducer });

const middleware = [thunk];

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const enhancer = composeEnhancers(applyMiddleware(...middleware));

const rootReducer = (state, action) => {
  if (action.type === "RESET_STORE") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};
const store = createStore(rootReducer, enhancer);
export { store };

const options = {
  refreshOnCheckAuth: true,
  redirectPath: "/",
  validateSession: (session) => getIsAuthenticated(session),
};

sessionService
  .initSessionService(store, options)
  .then(() =>
    console.log(
      "Redux React Session is ready and a session was refreshed from your storage"
    )
  )
  .catch(() =>
    console.log(
      "Redux React Session is ready and there is no session in your storage"
    )
  );
